import { ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE } from 'fhir/constants'

export enum AssessmentStatus {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  PENDING_QA = 'pending-qa',
  PENDING_QA_EDITS = 'pending-qa-edits',
  PENDING_APPROVAL = 'pending-approval',
  ENTERED_IN_ERROR = 'entered-in-error'
}

export const COMPLETION_STATUSES = [AssessmentStatus.COMPLETED, AssessmentStatus.PENDING_APPROVAL]

export const ASSESSMENT_TYPE_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/assessment-type`
export const ASSESSMENT_VERSION_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/assessment-version`
export const NON_DELETED_ASSESSMENT_STATUSES = [
  AssessmentStatus.IN_PROGRESS,
  AssessmentStatus.COMPLETED,
  AssessmentStatus.PENDING_QA,
  AssessmentStatus.PENDING_QA_EDITS,
  AssessmentStatus.PENDING_APPROVAL
]
